export const truncateString = (str: string, size: number, suffix: string = '...'): string =>
    str.length < size ? str : str.substring(0, size) + suffix;
